export const siteName = 'DanmakuRocks';

export const twitchClientId = 'itu9mi8vwu43w4bpkgwzzt8ayy2afh';
